import { render, staticRenderFns } from "./MobilePosterImage.vue?vue&type=template&id=c65285d2&scoped=true&"
import script from "./MobilePosterImage.vue?vue&type=script&lang=ts&"
export * from "./MobilePosterImage.vue?vue&type=script&lang=ts&"
import style0 from "./MobilePosterImage.vue?vue&type=style&index=0&id=c65285d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65285d2",
  null
  
)

export default component.exports